import { render, staticRenderFns } from "./home-fotor.vue?vue&type=template&id=f0826018&scoped=true"
import script from "./home-fotor.vue?vue&type=script&lang=js"
export * from "./home-fotor.vue?vue&type=script&lang=js"
import style0 from "./home-fotor.vue?vue&type=style&index=0&id=f0826018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0826018",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpenInBrowser: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/common/OpenInBrowser.vue').default})
